import { createIcon } from '@chakra-ui/icons';

export const Delete = createIcon({
  displayName: 'Delete',
  viewBox: '0 0 20 24',
  d: 'M16.3019 21.7358V8.15094H18.566V24H1.35849V8.15094H3.62264V21.7358H16.3019ZM6.33962 8.15094H8.60377V19.4717H6.33962V8.15094ZM11.3208 8.15094H13.5849V19.4717H11.3208V8.15094ZM15.283 4.07547H19.9245V6.33962H0V4.07547H4.64151L6.01415 0H13.9104L15.283 4.07547ZM7.03302 4.07547H12.8915L12.283 2.26415H7.64151L7.03302 4.07547Z',
});
